import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import commonFormMeta from '@Shared/components/form/commonFormMeta';
import { capitalize } from '@Shared/utils/helpers';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface IManualCardTopUpFormMeta {
    idBank: FormInputMeta;
    nameBank: FormInputMeta;
    agency: FormInputMeta;
    microFilmRefNumber: FormInputMeta;
    PAN: FormInputMeta;
    client: FormInputMeta;
    holderName: FormInputMeta;
    reloadFee: FormInputMeta;
    paymentMode: FormInputMeta;
    dateEffectiveRecharge: FormInputMeta;
    rechargeAmount: FormInputMeta;
    
    schema: any;
  }

const ManualCardTopUpFormMeta = {} as IManualCardTopUpFormMeta;

ManualCardTopUpFormMeta.idBank = {
  name: 'idBank',
  type: 'text',
  label: 'ID Banque',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ManualCardTopUpFormMeta.nameBank = {
  name: 'nameBank',
  type: 'text',
  label: 'Raison sociale',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ManualCardTopUpFormMeta.agency = {
  name: "agency",
  label: "Agence",
  type: "select",
  options:  [
      {
        label: 'Agence A',
        value: 'a'
      },
      {
        label: 'Agence B',
        value: 'b',
      },
      {
        label: 'Agence C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}

ManualCardTopUpFormMeta.microFilmRefNumber = {
  name: 'microFilmRefNumber',
  type: 'text',
  label: 'N° Reference microfilm',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ManualCardTopUpFormMeta.PAN = {
  name: "PAN",
  label: "PAN",
  type: "select",
  options:  [
      {
        label: 'PAN A',
        value: 'a'
      },
      {
        label: 'PAN B',
        value: 'b',
      },
      {
        label: 'PAN C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}

ManualCardTopUpFormMeta.client = {
  name: 'client',
  type: 'text',
  label: 'Client',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};
ManualCardTopUpFormMeta.holderName = {
  name: 'holderName',
  type: 'text',
  label: 'Nom du porteur',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ManualCardTopUpFormMeta.reloadFee = {
  name: "reloadFee",
  label: "Reload Fee",
  type: "select",
  options:  [
      {
        label: 'Fee A',
        value: 'a'
      },
      {
        label: 'Fee B',
        value: 'b',
      },
      {
        label: 'Fee C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}

ManualCardTopUpFormMeta.paymentMode = {
  name: "paymentMode",
  label: "Mode de paiement",
  type: "select",
  options:  [
      {
        label: 'Mode A',
        value: 'a'
      },
      {
        label: 'Mode B',
        value: 'b',
      },
      {
        label: 'Mode C',
        value: 'b',
      },
    ],
    validation: yup.string().required("Ce champ est requis"),
}

ManualCardTopUpFormMeta.dateEffectiveRecharge = {
  name: 'dateEffectiveRecharge',
  type: 'text',
  label: 'Date Recharge Effective',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ManualCardTopUpFormMeta.rechargeAmount = {
  name: 'rechargeAmount',
  type: 'text',
  label: 'Montant Recharge',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ManualCardTopUpFormMeta.schema = yup.object().shape(getValidationSchema(ManualCardTopUpFormMeta));

export default ManualCardTopUpFormMeta;